// @flow
import environment from '../../../../environment';
import { deleteCreator } from '../../../../http';

export const endpoints = Object.freeze({
  CANCEL_ORDER: `${environment.apiUrl}/purchase/:id`,
});

export const cancelOrderApi = deleteCreator(fetch, endpoints.CANCEL_ORDER);



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/looking-for-traveler/api.js